

























































































































































import { AllGeeksSingleSelect } from '@/components';
import { AcceptRequestModal, RejectRequestModal } from '@/components/admin-panel';
import { GeekItem } from '@/models';
import {
  WaitingRequest,
  WaitingRequestFilters,
  WaitingWithdrawalFilters,
  WaitingRequestForm,
  gCoinsRequestStatus,
} from '@/models/admin-panel';
import { ToastsService, buildGeekName } from '@/utils';
import { collapseMixin } from '@/shared';
import { typedStore, Actions, Getters } from '@/store';
import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import debounce from 'lodash.debounce';

export default mixins(collapseMixin).extend({
  name: 'WaitingRequestsTab',
  components: {
    AcceptRequestModal,
    RejectRequestModal,
    AllGeeksSingleSelect,
  },
  data() {
    return {
      reqestContext: (null as unknown) as WaitingRequest,
      filters: {
        immediate: {
          geekId: (null as unknown) as string,
        },
        debounce: {
          reason: '',
        },
      },
      loader: {
        isWaitingRequestsListPending: false,
      },
      gCoinsRequestStatus,
    };
  },
  computed: {
    collapsibleItems(): WaitingRequest[] {
      return typedStore(this).state.gCoins.waitingRequests;
    },
    areMoreItemsAvailable(): boolean {
      return this.collapsibleItems.length < typedStore(this).state.gCoins.pagination.totalCount
        && this.collapsibleItems.length > 0;
    },
    filteredGeeks(): GeekItem[] {
      return typedStore(this).getters[Getters.geek.filtered];
    },
    flattenFilters(): WaitingRequestFilters {
      return {...this.filters.debounce, ...this.filters.immediate};
    },
  },
  methods: {
    async fetchWaitingRequests() {
      this.loader.isWaitingRequestsListPending = true;
      try {
        await this.$store.dispatch(Actions.gCoins.fetchWaitingRequests, this.flattenFilters);
      } finally {
        this.loader.isWaitingRequestsListPending = false;
      }
    },
    async fetchMoreWaitingRequests() {
      this.loader.isWaitingRequestsListPending = true;
      try {
        await this.$store.dispatch(Actions.gCoins.fetchMoreWaitingRequests, this.flattenFilters);
      } finally {
        this.loader.isWaitingRequestsListPending = false;
      }
    },
    updateRequestedBy(selectedGeek: GeekItem) {
      this.filters.immediate.geekId = selectedGeek ? selectedGeek.id : (null as unknown) as string;
    },
    acceptRequest(waitingRequest: WaitingRequest) {
      this.reqestContext = waitingRequest;
      this.$bvModal.show('accept-request-modal');
    },
    async orderRequest(waitingRequest: WaitingRequest) {
      this.loader.isWaitingRequestsListPending = true;
      try {
        const fromData = {
          id: waitingRequest.id,
        } as WaitingRequestForm;

        await this.$store.dispatch(Actions.gCoins.orderRequest, fromData);
        await this.$store.dispatch(Actions.gCoins.fetchWaitingRequests, this.flattenFilters);

        const toastText = this.$t(
          'admin-panel.gcoins.tabs.waiting-requests.toasts.ordered',
          { geekName: buildGeekName(waitingRequest?.geek) },
        ) as string;
        ToastsService.success(toastText);
      } finally {
        this.loader.isWaitingRequestsListPending = false;
      }
    },
    async confirmRequest(waitingRequest: WaitingRequest) {
      this.loader.isWaitingRequestsListPending = true;
      try {
        const fromData = {
          id: waitingRequest.id,
        } as WaitingRequestForm;

        await this.$store.dispatch(Actions.gCoins.confirmRequest, fromData);
        await this.$store.dispatch(Actions.gCoins.fetchWaitingRequests, this.flattenFilters);

        const toastText = this.$t(
          'admin-panel.gcoins.tabs.waiting-requests.toasts.confirmed',
          { geekName: buildGeekName(waitingRequest?.geek) },
        ) as string;
        ToastsService.success(toastText);
      } finally {
        this.loader.isWaitingRequestsListPending = false;
      }
    },
    rejectRequest(waitingRequest: WaitingRequest) {
      this.reqestContext = waitingRequest;
      this.$bvModal.show('reject-request-modal');
    },
    buildGeekName,
  },
  watch: {
    'filters.debounce': {
      handler: debounce(function(this: any) {
        this.fetchWaitingRequests();
      }, 1000),
      deep: true,
    },
    'filters.immediate': {
      handler(this: any) {
        this.fetchWaitingRequests();
      },
      deep: true,
      immediate: true,
    },
  },
});
